export default __webpack_public_path__ + "static/media/banner-seguro-saude-mobile.56424aa1.png";